import { render, staticRenderFns } from "./offer.vue?vue&type=template&id=10eb412f&scoped=true&"
import script from "./offer.vue?vue&type=script&lang=js&"
export * from "./offer.vue?vue&type=script&lang=js&"
import style0 from "./offer.vue?vue&type=style&index=0&id=10eb412f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb412f",
  null
  
)

export default component.exports